/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Process_TabInputs */

const en_input_process_tab = /** @type {(inputs: Input_Process_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input process`)
};

const nl_input_process_tab = /** @type {(inputs: Input_Process_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoerproces`)
};

/**
* | output |
* | --- |
* | "Input process" |
*
* @param {Input_Process_TabInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const input_process_tab = /** @type {((inputs?: Input_Process_TabInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Process_TabInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_input_process_tab(inputs)
	return en_input_process_tab(inputs)
});